import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Grid, IconButton } from "@mui/material";
import ScreenDropdown from "app/components/common/ScreenDropdown";
import Table from "app/components/common/Table";
import EducationAttainmentChart from "./Screen6Graphs/EducationAttainmentChart";
import CteBarGraph from "./Screen6Graphs/CteBarGraph";
import "./Screen6.css";
import SunburstChart from "app/components/charts/SunburstChart";
import SunburstChart2 from "app/components/charts/SunburstChart2";
import { BootstrapInput } from "app/components/common/BootStrapInput";
import SubGroupDoubleBarChart from "./Screen6Graphs/SubGroupDoubleBarChart"
import CompletionOverTimeLineChart from "./Screen6Graphs/CompletionOverTimeLineChart"
import CompletionStackedBarChart from "./Screen6Graphs/CompletionStackedBarChart"
import SubGroupStackedBarChart from "./Screen6Graphs/SubGroupStackedBarChart"
import LibraryBooksIcon from '@mui/icons-material/LibraryBooks';

import { FormControl, MenuItem, Select, Typography } from "@mui/material";
import {
  fetchAverageDataScreen6,
  fetchEducationSummaryDataScreen6,
  fetchEducationAttainmentDataScreen6,
  fetchCTEfilterDataScreen6,
  fetchCteBarChartScreen6,
  fetchCteLeftSunburstScreen6,
  fetchCteRightSunburstScreen6,
  fetchEducationSummaryCardsScreen6,
  fetchGradPostEducationSummaryScreen6,
  fetchGradPostSubgroupSummaryScreen6,
  fetchNAEPTableDataScreen6,
  fetchCompletionsOverTimeScreen6,
  fetchCompletionsByDegreeTypeScreen6
} from "../../7screen/redux/screen6/actions";

import { changeScreenOrientation, updateDataSources } from "../../7screen/redux/ScreensCommon/actions";
import { Co2Sharp } from "@mui/icons-material";
import { logActivity } from "../redux/api/loggingAPI";
import { UserActivityConstants } from "api/UserActivityConstants";

const Screen6NavTitles = ["Summary", "Post-Secondary", "Career and Technical Education"];

class Screen6 extends Component {
  constructor(props) {
    super(props);
    this.state = {
      subMenuIndex: 0,
      cteFilterDropdown: [],
      cteFilter: "All",
      cteLeftSunburstDataScreen6: [],
      cteRightSunburstDataScreen6: [],
    };
  }

  handleCteFilterChange = (event) => {
    this.setState({ cteFilter: event.target.value });
    this.props.fetchCteBarChartScreen6(
      this.props.regionSelected,
      event.target.value
    );
    this.props.fetchCteLeftSunburstScreen6(
      this.props.regionSelected,
      event.target.value
    );
    this.props.fetchCteRightSunburstScreen6(
      this.props.regionSelected,
      event.target.value
    );

    logActivity({
      screen : UserActivityConstants.SCREEN6.NAME,
      action_type : UserActivityConstants.ACTION_TYPES.CLICK,
      action_target : event.target.value,
      action : UserActivityConstants.SCREEN6.ACTIONS.SELECT_CTE_FILTER
    })
  };

  changeSubMenu = (i) => {
    // this.subMenuIndex = i;
    this.setState({ subMenuIndex: i });
    logActivity({
      screen : UserActivityConstants.SCREEN6.NAME,
      action_type : UserActivityConstants.ACTION_TYPES.CLICK,
      action_target : Screen6NavTitles[i],
      action : UserActivityConstants.SCREEN6.ACTIONS.CHANGE_SUB_MENU
    })
  };

  refreshData() {
    this.props.fetchAverageDataScreen6(this.props.regionSelected);
    this.props.fetchEducationSummaryDataScreen6(this.props.regionSelected);
    this.props.fetchEducationAttainmentDataScreen6(this.props.regionSelected);
    this.props.fetchEducationSummaryCardsScreen6(this.props.regionSelected);
    this.props.fetchGradPostEducationSummaryScreen6(this.props.regionSelected);
    this.props.fetchGradPostSubgroupSummaryScreen6(this.props.regionSelected);
    this.props.fetchNAEPTableDataScreen6();
    this.props.fetchCompletionsOverTimeScreen6(this.props.regionSelected);
    this.props.fetchCompletionsByDegreeTypeScreen6(this.props.regionSelected);
    this.props.fetchCTEfilterDataScreen6();
    this.props.fetchCteBarChartScreen6(
      this.props.regionSelected,
      this.state.cteFilter
    );
    this.props.fetchCteLeftSunburstScreen6(
      this.props.regionSelected,
      this.state.cteFilter
    );
    this.props.fetchCteRightSunburstScreen6(
      this.props.regionSelected,
      this.state.cteFilter
    );
  }

  componentDidMount() {
    this.refreshData();
    this.setState({
      cteLeftSunburstDataScreen6: this.props.cteLeftSunburstDataScreen6,
      cteRightSunburstDataScreen6: this.props.cteRightSunburstDataScreen6,
    });
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.regionSelected !== prevProps.regionSelected) {
      this.refreshData();
    }
    if (
      this.props.cteFilterDataScreen6 !== prevProps.cteFilterDataScreen6
    ) {
      this.setState({
        cteFilterDropdown: this.props.cteFilterDataScreen6,
      });
      this.setState({
        cteLeftSunburstDataScreen6: [],
        cteRightSunburstDataScreen6: [],
      });
      setTimeout(() => {
        this.setState({
          cteLeftSunburstDataScreen6: this.props.cteLeftSunburstDataScreen6,
          cteRightSunburstDataScreen6: this.props.cteRightSunburstDataScreen6,
        });
      }, 1);
    }
  }

  handleDataSourceToggle = () => {
    this.props.updateDataSources()
    logActivity({
      screen : UserActivityConstants.SCREEN6.NAME,
      action_type : UserActivityConstants.ACTION_TYPES.CLICK,
      action_target : UserActivityConstants.COMMON_ACTIONS.TOGGLE_DATA_SOURCE,
      action : UserActivityConstants.COMMON_ACTIONS.TOGGLE_DATA_SOURCE
    })
  }

  render() {
    let averageData = this.props.averageDataScreen6;

    const tableData = {
      columns: [
        "Metric",
        "County",
        "Arizona",
        "Similar Counties",
        "United States",
      ],
      rows: Object.values(this.props.educationSummaryDataScreen6),
    };

    let naepTable = {
      columns: [
        "NAEP",
        "Arizona",
        "United States",
        "Rank"
      ],
      rows: Object.values(this.props.naepTableScreen6),
    };

    let gradTable = {
      columns: [
        "Metric",
        "County",
        "Arizona",
        "United States"
      ],
      rows: Object.values(this.props.gradPostSummaryScreen6),
    };

    let gradPostData = this.props.gradPostSubgroupSummaryScreen6;
    // console.log("gradPostData", gradPostData)

    let educationSummaryCardsData = this.props.educationSummaryCardsScreen6;

    let programNamesData = this.props.completionsByDegreeType[0];
    let completionsByDegreeTypeData = this.props.completionsByDegreeType[1];

    const educationAttainmentData = Object.values(
      this.props.educationAttainmentDataScreen6
    );
    return (
      <div className="screen-wrapper">
        <header className="screen-header">
          <IconButton
              id="data-sources-icon"
              style={{
                color: "white",
                marginLeft: 20,
                marginRight: -60,
                marginTop: -155,
                position: 'relative', // This is required for z-index to work
                zIndex: 1000,
              }}
              onClick={this.handleDataSourceToggle}
            >
              <LibraryBooksIcon className="swap-icon" />
            </IconButton>
          <div className="title">Education</div>
          <div className="screen-menu">
            {Screen6NavTitles.map((title, i) => (
              <div
                key={i}
                className={`screen-menu-item ${
                  this.state.subMenuIndex === i ? "selected" : ""
                }`}
                onClick={() => this.changeSubMenu(i)}
                style={{ whiteSpace: 'nowrap', zIndex: 1000 }}
              >
                {title}
                <br />
              </div>
            ))}
          </div>
        </header>

        {(this.state.subMenuIndex === 0 || this.state.subMenuIndex === 1) && (
          <Grid
            container
            className="screen-content-wrapper screen-content-wrapper-6"
          >
            <Grid
              container
              className="screen-content-grid-6"
              style={{ height: "915px" }}
            >
              <Grid item md={2.4} className="aggregated-metric-wrapper">
                <div
                  style={{ backgroundColor: "#005898" }}
                  className="rect-shape"
                >
                  <span style={{ display: "block" }}>Total Students</span>{" "}
                  <b>
                    {educationSummaryCardsData["Total Students"]
                      ? educationSummaryCardsData["Total Students"].toLocaleString("en-US")
                      : "NA"}
                  </b>
                </div>
              </Grid>
              <Grid item md={2.4} className="aggregated-metric-wrapper">
                <div
                  style={{ backgroundColor: "#6AA4DC" }}
                  className="rect-shape"
                >
                  <span style={{ display: "block" }}>AZ ELA</span>{" "}
                  <b>
                    {educationSummaryCardsData["ELA Grade 3"]
                      ? educationSummaryCardsData["ELA Grade 3"] + "%"
                      : "NA"}
                  </b>
                </div>
              </Grid>
              <Grid item md={2.4} className="aggregated-metric-wrapper">
                <div
                  style={{ backgroundColor: "#FFB607" }}
                  className="rect-shape"
                >
                  <span style={{ display: "block" }}>AZ Math</span>{" "}
                  <b>
                    {educationSummaryCardsData["Math Grade 8"]
                      ? educationSummaryCardsData["Math Grade 8"] + "%"
                      : "NA"}
                  </b>
                </div>
              </Grid>
              <Grid item md={2.4} className="aggregated-metric-wrapper">
                <div
                  style={{ backgroundColor: "#FB6A59" }}
                  className="rect-shape"
                >
                  <span style={{ display: "block" }}>High School Outcomes</span>{" "}
                  <b>
                    {educationSummaryCardsData["4Y Graduation"]
                      ? educationSummaryCardsData["4Y Graduation"] + "%"
                      : "NA"}
                  </b>
                </div>
              </Grid>
              <Grid
                item
                md={2.4}
                className="aggregated-metric-wrapper"
                style={{ paddingRight: 0 }}
              >
                <div
                  style={{ backgroundColor: "#DE3E40" }}
                  className="rect-shape"
                >
                  <span style={{ display: "block" }}>
                    Post-Secondary Enrollment
                  </span>{" "}
                  <b>
                    {educationSummaryCardsData["PostSecondary"]
                      ? educationSummaryCardsData["PostSecondary"] + "%"
                      : "NA"}
                  </b>
                </div>
              </Grid>
              {this.state.subMenuIndex === 0 && (
              <Grid item md={5}>
                <div className="graph-title table-title" style={{marginTop: "20px"}}>Education Summary</div>
                {naepTable ? (
                  <div className="table-container">
                    <Table
                      tableData={naepTable}
                      tableClass="educational-summary-table"
                    />
                  </div>
                ) : (
                  <div style={{ textAlign: "center" }}> No data available </div>
                )}
                {gradTable ? (
                  <div className="table-container">
                    <Table
                      tableData={gradTable}
                      tableClass="educational-postgrad-summary-table"
                    />
                  </div>
                ) : (
                  <div style={{ textAlign: "center" }}> No data available </div>
                )}
              </Grid>
              )}
              {this.state.subMenuIndex === 0 && (
              <Grid item md={7}>
                {Object.keys(gradPostData).length > 0 ? (
                  <div className="bar-graph-container">
                    <SubGroupStackedBarChart education_summary_data={gradPostData} />
                  </div>
                  ) : (
                    <div style={{ textAlign: "center", paddingTop: 400 }}>
                      {" "}
                      No data available{" "}
                    </div>
                )}
              </Grid>
              )}

              {this.state.subMenuIndex === 1 && (
                <Grid item md={5.5}>
                <div className="graph-title table-title" style={{marginTop: "40px"}}>Degree completion over time</div>
                {Object.keys(this.props.completionsOverTime).length > 0 ? (
                  <CompletionOverTimeLineChart completionData={this.props.completionsOverTime}/>
                ) : (
                  <div style={{ textAlign: "center" }}> No data available </div>
                  )}
                </Grid>
              )}
              {this.state.subMenuIndex === 1 && (
                <Grid item md={6.5}>
                <div className="graph-title table-title" style={{marginTop: "40px"}}>Completions by degree type</div>
                {Object.keys(this.props.completionsByDegreeType).length > 0 ? (
                  <CompletionStackedBarChart programNames={programNamesData} completionData={completionsByDegreeTypeData} />
                ) : (
                  <div style={{ textAlign: "center" }}> No data available </div>
                )}
                </Grid>
              )}
            </Grid>
          </Grid>

        )}
        {this.state.subMenuIndex === 2 && (
          <Grid
            container
            className="screen-content-wrapper screen-content-wrapper-6"
          >
            <Grid
              container
              className="screen-content-grid-6"
              // style={{ height: "915px" }}
              // direction="column"
              justifyContent="flex-start"
              alignItems="left"
            >
              <Grid item xs={5}>
                <div className="graph-wrapper screen-left-graph-container">
                  <div
                    className="graph-title-container-screen graph-title-container-screen3"
                    style={{ marginBottom: "20px" }}
                  >
                    <div className="graph-dropdown graph-dropdown-4">
                      <FormControl>
                        <Grid
                          container
                          spacing={2}
                          alignItems="center"
                          style={{ marginTop: 50, marginBottom: 20 }}
                        >
                          <Grid item>
                            {/* <Typography
                              variant="inherit"
                              className="form-metrics-header"
                            >
                              Subgroup
                            </Typography> */}
                            <Select
                              value={this.state.cteFilter}
                              onChange={(e) => this.handleCteFilterChange(e)}
                              input={<BootstrapInput />}
                              inputProps={{ "aria-label": "Without label" }}
                              MenuProps={{
                                PaperProps: { sx: { maxHeight: "400px" } },
                              }}
                              className="select-mui"
                              displayEmpty
                              style={{ width: "290px" }}
                            >
                              <MenuItem disabled value="">
                                <Typography variant="inherit" noWrap>
                                  Select a Subgroup
                                </Typography>
                              </MenuItem>
                              {this.props.cteFilterDataScreen6.length > 0
                                ? this.props.cteFilterDataScreen6.map(
                                    (name, i) => (
                                      <MenuItem key={i} value={name}>
                                        <Typography variant="inherit" noWrap>
                                          {name === "All" ? "All Subgroups" : name}
                                        </Typography>
                                      </MenuItem>
                                    )
                                  )
                                : null}
                            </Select>
                          </Grid>
                        </Grid>
                      </FormControl>
                    </div>
                  </div>
                </div>
              </Grid>
              <Grid
                container
                // className="screen-content-grid-6"
                // style={{ height: "915px" }}
                direction="row"
                justifyContent="space-between"
                alignItems="center"
              >
                <Grid item xs={4}>
                  <div className="graph-screen graph-screen3">
                    <CteBarGraph
                      data={this.props.cteBarChartDataScreen6}
                      subgroup={this.state.cteFilter}
                    />
                  </div>
                </Grid>
                <Grid item xs={4}>
                  <div className="graph-title graph-title-2 graph-title-sunburst">
                    CTE and Graduation
                  </div>
                  {this.state.cteLeftSunburstDataScreen6.length > 0 ? (
                    // <SunburstChart
                    //   containerId="sunburstChart"
                    //   data={this.state.cteLeftSunburstDataScreen6}
                    //   subgroup={this.state.cteFilter}
                    //   region={this.props.regionSelected}
                    //   remainingOptions={{
                    //     chart: {
                    //       animation: false,
                    //       type: "bar",
                    //       backgroundColor: "transparent",
                    //       height: 400,
                    //       width: 400,
                    //     },
                    //   }}
                    // />
                    <SunburstChart2
                      data={this.state.cteLeftSunburstDataScreen6}
                      subgroup={this.state.cteFilter}
                      region={this.props.regionSelected}
                    />
                  ) : (
                    // <SunburstChart2 />
                    <div style={{ width: 400, height: 400 }}></div>
                  )}
                </Grid>
                <Grid item xs={4}>
                  <div className="graph-title graph-title-2 graph-title-sunburst">
                    CTE and Path to College
                  </div>
                  {this.state.cteRightSunburstDataScreen6.length > 0 ? (
                    // <SunburstChart
                    //   containerId="sunburstChart"
                    //   data={this.state.cteRightSunburstDataScreen6}
                    //   subgroup={this.state.cteFilter}
                    //   region={this.props.regionSelected}
                    //   remainingOptions={{
                    //     chart: {
                    //       animation: false,
                    //       type: "bar",
                    //       backgroundColor: "transparent",
                    //       height: 400,
                    //       width: 400,
                    //     },
                    //   }}
                    // />
                    <SunburstChart2
                      data={this.state.cteRightSunburstDataScreen6}
                      subgroup={this.state.cteFilter}
                      region={this.props.regionSelected}
                    />
                  ) : (
                    <div style={{ width: 400, height: 400 }}></div>
                  )}
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        )}
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    orientationHorizontal: state.ScreensCommonReducer.orientationHorizontal,
    regionSelected: state.Screen1Reducer.regionSelected,
    displayDataSources: state.ScreensCommonReducer.displayDataSources,
    averageDataScreen6: { ...state.Screen6Reducer.averageDataScreen6 },
    educationSummaryDataScreen6: {
      ...state.Screen6Reducer.educationSummaryDataScreen6,
    },
    educationAttainmentDataScreen6: {
      ...state.Screen6Reducer.educationAttainmentDataScreen6,
    },
    educationSummaryCardsScreen6: { ...state.Screen6Reducer.educationSummaryCardsScreen6 },
    gradPostSummaryScreen6: { ...state.Screen6Reducer.gradPostSummaryScreen6 },
    gradPostSubgroupSummaryScreen6: { ...state.Screen6Reducer.gradPostSubgroupSummaryScreen6 },
    naepTableScreen6: { ...state.Screen6Reducer.naepTableScreen6 },
    completionsOverTime: { ...state.Screen6Reducer.completionsOverTimeScreen6},
    completionsByDegreeType: { ...state.Screen6Reducer.completionsByDegreeTypeScreen6},
    cteFilterDataScreen6: Array.isArray(
      state.Screen6Reducer.cteFilterDataScreen6
    )
      ? [...state.Screen6Reducer.cteFilterDataScreen6]
      : [],
    cteBarChartDataScreen6: { ...state.Screen6Reducer.cteBarChartDataScreen6 },
    cteLeftSunburstDataScreen6: Array.isArray(
      state.Screen6Reducer.cteLeftSunburstDataScreen6
    )
      ? [...state.Screen6Reducer.cteLeftSunburstDataScreen6]
      : [],
    cteRightSunburstDataScreen6: Array.isArray(
      state.Screen6Reducer.cteRightSunburstDataScreen6
    )
      ? [...state.Screen6Reducer.cteRightSunburstDataScreen6]
      : [],
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      changeScreenOrientation,
      updateDataSources,
      fetchAverageDataScreen6,
      fetchEducationSummaryDataScreen6,
      fetchEducationAttainmentDataScreen6,
      fetchCTEfilterDataScreen6,
      fetchCteBarChartScreen6,
      fetchCteLeftSunburstScreen6,
      fetchCteRightSunburstScreen6,
      fetchEducationSummaryCardsScreen6,
      fetchGradPostEducationSummaryScreen6,
      fetchGradPostSubgroupSummaryScreen6,
      fetchNAEPTableDataScreen6,
      fetchCompletionsOverTimeScreen6,
      fetchCompletionsByDegreeTypeScreen6
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(Screen6);
